var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 24H4.92188C2.20795 24 0 21.792 0 19.0781V4.92188C0 2.20795 2.20795 0 4.92188 0H19.0781C21.792 0 24 2.20795 24 4.92188V19.0781C24 21.792 21.792 24 19.0781 24Z",
    fill: "#00C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 0H12V24H19.0781C21.792 24 24 21.792 24 19.0781V4.92188C24 2.20795 21.792 0 19.0781 0Z",
    fill: "#00AAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38978 18.4929C7.17299 18.8684 6.77825 19.0786 6.37292 19.0786C6.17422 19.0786 5.97303 19.0281 5.78895 18.9219C5.22936 18.5988 5.03694 17.8807 5.36 17.3211L5.59049 16.9219H8.29681L7.38978 18.4929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17969 15.9844C4.53352 15.9844 4.00781 15.4587 4.00781 14.8125C4.00781 14.1663 4.53352 13.6406 5.17969 13.6406H7.48491L10.6468 8.16404L9.78989 6.67978C9.46683 6.12019 9.6592 5.40206 10.2188 5.07896H10.2188C10.7784 4.75589 11.4966 4.94836 11.8196 5.50791L12 5.82033L12.1804 5.50796C12.5036 4.94831 13.2217 4.75594 13.7812 5.079C14.0522 5.23552 14.2462 5.48822 14.3272 5.79057C14.4082 6.09291 14.3666 6.40875 14.2101 6.67983L10.1912 13.6406H12.7262L14.0794 15.9844H5.17969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8204 15.9844H17.8683L18.64 17.321C18.9631 17.8806 18.7707 18.5987 18.2111 18.9218C18.0305 19.026 17.8301 19.0793 17.627 19.0793C17.5252 19.0793 17.4228 19.066 17.3218 19.0389C17.0194 18.9578 16.7667 18.7639 16.6102 18.4928L12.5413 11.4452L13.8944 9.10149L16.5151 13.6406H18.8204C19.4665 13.6406 19.9922 14.1663 19.9922 14.8125C19.9922 15.4587 19.4665 15.9844 18.8204 15.9844Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6406V15.9844H14.0794L12.7262 13.6406H12Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3272 5.79052C14.2461 5.48817 14.0522 5.23542 13.7812 5.07896C13.2217 4.75589 12.5035 4.94822 12.1804 5.50791L12 5.82028V10.5078L14.2101 6.67978C14.3666 6.40871 14.4082 6.09291 14.3272 5.79052Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/AppStore.b3b61f48fb289bb6e1b77ad5752925be.svg";
export { ForwardRef as ReactComponent };